import { RouteConfig } from "vue-router";
import { routes as cadastrosRoutes } from "@/views/private/cadastros/router";
import { routes as contabilRoutes } from "@/views/private/contabil/router";
import { routes as orcamentoAutoOnline } from "@/views/private/orcamento-auto-online/router";
import { routes as perfil } from "@/views/private/perfil/router";
import { routes as administrativoRoutes } from "@/views/private/administracao/router";

import { routes as solicitacoes } from "@/views/private/solicitacoes/router";

const routes: Array<RouteConfig> = [
  {
    path: "/auth",
    name: "AuthHome",
    component: () => import(/* webpackChunkName: "auth" */ "@/views/private/AuthHome.vue"),
    children: [
      {
        path: "/home-page",
        name: "HomePage",
        component: () => import(/* webpackChunkName: "auth" */ "@/views/private/HomePage.vue"),
      },
      ...cadastrosRoutes,
      ...contabilRoutes,
      ...orcamentoAutoOnline,
      ...perfil,
      ...administrativoRoutes,
      ...solicitacoes
    ],
  },
];

export default routes;
